import { render, staticRenderFns } from "./MBarcodeScanner.vue?vue&type=template&id=0be1fe43&scoped=true&"
import script from "./MBarcodeScanner.vue?vue&type=script&lang=js&"
export * from "./MBarcodeScanner.vue?vue&type=script&lang=js&"
import style0 from "./MBarcodeScanner.vue?vue&type=style&index=0&id=0be1fe43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be1fe43",
  null
  
)

export default component.exports